var _defs, _path, _rect, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.4 425.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #e5ab31;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #f7dca2;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #ddb641;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #e0a01a;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #d89a18;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #efbf55;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #f7cc59;\r\n      }\r\n\r\n      .st7 {\r\n        fill: #e7b841;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #ddae2f;\r\n      }\r\n\r\n      .st9 {\r\n        fill: #f7db92;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.5,216.2c-5.2,0-9.5-4.2-9.5-9.5,0-5.2,4.2-9.5,9.5-9.5s9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5ZM61.5,199c-4.2,0-7.7,3.4-7.7,7.7s3.4,7.7,7.7,7.7,7.7-3.4,7.7-7.7,0,0,0,0c0-4.2-3.4-7.7-7.7-7.7Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 60.6,
    y: 0,
    width: 1.8,
    height: 198.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.2,348.6l-3.6,4.5s4.9,16.2,7,26.4c3.5-11.5,7.1-26.5,7.1-26.5,0,0-3.7-3-3.8-4.4s-6.7,0-6.7,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.8,339.2s-2.7,4.1,2.3,8.6,18.4,3.2,21.6-.8c2.7-3.3,2.9-7.1,1.6-9.1s-25.6,1.3-25.6,1.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.5,328.3s-5.2,4.6,4.5,9.6,35.1,3.5,41.3-.9c5.2-3.7,5.6-8,3-10.2s-48.7,1.5-48.7,1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31,320.2s-6.5,4.9,5.5,10.1c12.1,5.2,43.8,3.7,51.5-1,6.5-3.9,6.9-8.4,3.8-10.7s-60.8,1.6-60.8,1.6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "26.4 312.8 30.3 310.8 94.3 309.9 96.1 310.8 81 317.8 34.1 319.8 26.4 312.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.5,256s-6.5-13.3,11.7-18.4,24.3-18.4,24-21.7c3.6,12.4,25.7,20.8,35.1,24.6s4.2,15.5,4.2,15.5H25.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M49.1,256s-6.4-4.1-5.7-10.5,18.6-17.9,17.8-29.4c3.2,13.4,9.9,17.6,16.1,23.1s5,12,0,16.5c-10.9,1.3-28.2.4-28.2.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.1,256c-2.2-2.9-3.1-6.5-2.7-10.1.7-6.4,15.5-18.3,14.8-29.9,3.2,13.4,6.5,18,12.8,23.5s8.3,11.6,3.3,16c-10.9,1.4-28.2.5-28.2.5Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "84 322.6 33.2 321.8 29.5 257.3 88.1 255.4 84 322.6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "84 322.6 92.9 318.6 101.9 259.5 88.1 255.4 84 322.6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "33.2 321.8 29.5 257.3 24 261.5 29.5 318.5 33.2 321.8"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.6 265 89.3 261.3 29.5 261.3 22.7 266.2 22.3 257.3 29.5 251.2 90.4 251.2 104.2 255.4 103.6 265"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "89.3 261.3 29.5 261.3 29.5 251.2 90.4 251.2 89.3 261.3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "26.4 312.8 32.9 316.1 81.9 316.1 96.1 310.8 94.8 321.8 81.8 326.8 33.2 324.8 26.4 320.7 26.4 312.8"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.9 316.1 81.9 316.1 81.8 326.8 33.2 324.8 32.9 316.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.7,272.1h-2.7c-3.1-4.2-7.4-6.8-12.2-6.8s-9,2.6-12.2,6.8h-3.3c-1.9,0-3.5,1.6-3.5,3.5h0v26.7c0,1.9,1.6,3.5,3.5,3.5,0,0,0,0,0,0h3.1c3.2,4.3,7.5,7,12.4,7s9.2-2.7,12.4-7h2.5c1.9,0,3.5-1.6,3.5-3.5v-26.7c0-1.9-1.6-3.5-3.5-3.5h0Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M71.2,274.8h-2.2c-2.6-3.5-6.2-5.7-10.2-5.7s-7.6,2.2-10.2,5.7h-2.8c-1.6,0-2.9,1.3-2.9,2.9v22.4c0,1.6,1.3,2.9,2.9,2.9h2.6c2.7,3.6,6.3,5.9,10.4,5.9s7.7-2.2,10.4-5.9h2.1c1.6,0,2.9-1.3,2.9-2.9h0v-22.4c0-1.6-1.3-2.9-2.9-2.9Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.2,300.2v-20.8h-.6c-2.6-3.5-6.2-5.7-10.2-5.7s-7.6,2.2-10.2,5.7h-2.8c-1.6,0-2.9,1.3-2.9,2.9v20.8h.9c2.7,3.6,6.3,5.9,10.4,5.9s7.7-2.2,10.4-5.9h2.1c1.6,0,2.9-1.3,2.9-2.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.6,272.6h-.6c-.3-3.8-1-6.1-2-6s-2.2,2.5-3.2,6.4h-.7c-.4,0-.9,1.5-1.1,3.3l-2.4,24.5c-.2,1.8,0,3.2.4,3.1h.7c.3,3.9,1,6.2,2,6.2s2.2-2.6,3.3-6.6h.5c.4,0,.9-1.5,1.1-3.3l2.4-24.5c.2-1.8,0-3.2-.4-3.2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.8,275.1h-.5c-.3-3.2-.8-5.1-1.7-5s-1.8,2.1-2.7,5.4h-.6c-.3,0-.8,1.3-.9,2.8l-2,20.5c-.2,1.5,0,2.7.4,2.6h.6c.2,3.3.8,5.3,1.7,5.2s1.9-2.2,2.8-5.6h.5c.3,0,.8-1.3.9-2.8l2-20.5c.2-1.5,0-2.8-.4-2.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M26.8,274.8h.2c0-3.9,0-6.4.4-6.6s.8,1.8,1.3,5.2l.2-.2c.1-.1.4,1.2.5,2.9l1.9,23c.2,1.1.2,2.1,0,3.2l-.2.2c0,3.9,0,6.4-.4,6.7s-.8-1.8-1.4-5.4h-.2c-.1.2-.4-1-.5-2.7l-1.9-23c-.2-1.1-.2-2.2,0-3.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M27.1,277h.2c0-3.3,0-5.4.3-5.5s.7,1.5,1.1,4.4h.2c.3.6.4,1.4.4,2.2l1.6,19.4c.1.9.1,1.8,0,2.7h-.2c0,3.4,0,5.5-.3,5.7s-.7-1.5-1.1-4.6h-.1c-.3-.7-.4-1.5-.4-2.3l-1.6-19.4c-.1-.8.9-1.8,0-2.7Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.3,216.2c0,2.7-2.1,4.9-4.8,4.9-2.7,0-4.9-2.1-4.9-4.8,0-2.7,2.1-4.9,4.8-4.9,0,0,0,0,0,0,2.7,0,4.8,2.1,4.8,4.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 61.5,
    cy: 214.4,
    r: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapOrange);
export default __webpack_public_path__ + "static/media/Shap_Orange.54bf48daa24b421dcd7ec6d2a11edc00.svg";
export { ForwardRef as ReactComponent };